/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
  ExtendedBox,
  ExtendedFlex,
  Heading,
  Body,
  MiniEssay,
} from '../../coreui';

import VisibilityTrigger from '../../components/VisibilityTrigger';
import Container from '../../components/Container';
import Divider from '../../components/Divider';
import FadeIn from '../../components/FadeIn';

const Access = ({
  heading,
  insights,
  ...additionalProps
}) => {
  return (
    <ExtendedBox
      py={[60, 80, 100, 120, 140]}
      {...additionalProps}
    >
      <Container
        align="center"
        type="simple"
      >
        <ExtendedBox
          maxWidth={[null, 450, 550, 650, 750]}
        >
          <VisibilityTrigger
            trigger="isVisible"
          >
            <MiniEssay
              header={heading}
              animatedFadeIn
            />
          </VisibilityTrigger>
        </ExtendedBox>
      </Container>
      <Container
        type="simple"
        justifyContent="space-between"
      >
        {
          insights.map((insight, index) => {
            return (
              <FadeIn
                key={insight.heading}
                fadeInIndex={1}
              >
                <ExtendedBox
                  mt={40}
                  maxWidth={[null, 400, 500, 600]}
                  {...(index === 0 ? {
                    mr: [null, 25],
                  } : {
                    ml: [null, 25],
                  })}
                >
                  <Heading
                    type="H8"
                    display="block"
                    textAlign="center"
                    alignSelf="center"
                    mb={40}
                  >
                    {insight.heading}
                  </Heading>
                  {
                    insight.items.map((item, itemIndex) => {
                      return (
                        <FadeIn
                          key={item}
                          fadeInIndex={2 + itemIndex}
                        >
                          <Divider
                            type="horizontal"
                          />
                          <ExtendedFlex
                            align="flex-start"
                          >
                            <Body
                              key={item}
                              type="B1"
                              display="block"
                              mt={10}
                              ml={20}
                            >
                              {item}
                            </Body>
                          </ExtendedFlex>
                        </FadeIn>
                      );
                    })
                  }
                </ExtendedBox>
              </FadeIn>
            );
          })
        }
      </Container>
    </ExtendedBox>
  );
};

Access.propTypes = {
  heading: PropTypes.string,
  insights: PropTypes.arrayOf(PropTypes.shape({
    heading: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.string),
  })),
};

export default Access;
